import client from '@common/utils/rest';
import {sanitize} from "@common/utils/sanitize";

const URL_PREFIX = 'apis/userMaintenance';

export const getProfileImageUrl = (sec) => {
  return `profiles.html?sec=${sec}`
};

export const updateProfile = (data) => {
  const formData = new FormData();

  Object.keys(data).forEach((key) => {
    if (data[key]) {
      formData.append(key, sanitize(data[key]));
    }
  });

  return client({
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    path: `${URL_PREFIX}/userprofile`,
    method: 'POST',
    entity: formData,
  });
};

export const getProfileSettings = (userName) => {
  return client({
    path: `${URL_PREFIX}/userprofilesettings/${userName}`,
    method: 'GET',
  }).then((response) => {
    return response.entity.payLoad;
  });
};

export const updateProfileSettings = (data) => {
  return client({
    path: `${URL_PREFIX}/userprofilesettings`,
    method: 'POST',
    entity: data,
  });
};

export const getModuleVisibility = (userName) => {
  return client({
    path: `${URL_PREFIX}/navSettings/${userName}`,
    method: 'GET',
  }).then((response) => {
    return response.entity.payLoad;
  });
};